"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class DataUtil
 */
var DataUtil = /** @class */ (function () {
    function DataUtil() {
    }
    /**
     * Checks if Data object is of type VectorData.
     */
    DataUtil.isVector = function (v) {
        return v.exampleFeatures !== undefined;
    };
    /**
     * Checks if Data object is of type RasterData.
     */
    DataUtil.isRaster = function (r) {
        return r.rasterBandInfo !== undefined;
    };
    return DataUtil;
}());
exports.default = DataUtil;
//# sourceMappingURL=DataUtil.js.map